import { useState } from 'react';
import { getCookieValue, setCookieValue, removeCookie } from '../app/cookie.utils.js';
export var CookieEnum;
(function (CookieEnum) {
    CookieEnum["QUICK_QUOTE_COOKIE_NAME"] = "ctmQuickQuotes";
    CookieEnum["GPX_COOKIE_NAME"] = "gpx_valuation";
    CookieEnum["FINANCE_COOKIE_NAME"] = "financeShowcase";
    CookieEnum["PLATFORM_COOKIE_NAME"] = "bucket";
    CookieEnum["AB_TEST_GROUPS_NAME"] = "abTestGroups";
    CookieEnum["COOKIE_POLICY_NAME"] = "cookiePolicy";
    CookieEnum["URS_ID_NAME"] = "ursid";
    CookieEnum["USER_ID_NAME"] = "userid";
    CookieEnum["USER_TOKEN_NAME"] = "userToken";
    CookieEnum["SESSION_VARIABLE_NAME"] = "sessVar";
    CookieEnum["ACCEPT_AT_COOKIES"] = "acceptATCookies";
})(CookieEnum || (CookieEnum = {}));
export const COOKIES_REQUIRING_CONSENT = [CookieEnum.AB_TEST_GROUPS_NAME];
const useCookie = (key, defaultValue) => {
    const getCookie = () => getCookieValue(key) || defaultValue;
    const [cookie, setCookie] = useState(getCookie());
    const updateCookie = (value, expires) => {
        setCookie(value);
        setCookieValue(key, value, expires);
    };
    const removeCookieValue = () => {
        setCookie('');
        removeCookie(key);
    };
    return { cookie, updateCookie, removeCookieValue };
};
export default useCookie;
